import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

import { TableModule } from 'primeng/table';
import { ProductDetailsHeaderComponent } from '../product/product-details-header/product-details-header.component';
import { ShippingSelectorComponent } from '../product/shipping-selector/shipping-selector.component';
import { MenuModule } from 'primeng/menu';
import { QuantitySelectorComponent } from '../product/quantity-selector/quantity-selector.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

import { DeliveryItemsCardListComponent } from './delivery-items-card-list/delivery-items-card-list.component';
import { DeliveryItemsTableShippingNameComponent } from './delivery-items-table-shipping-name/delivery-items-table-shipping-name.component';

import { CommonModule } from '@angular/common';
import { DeliveryItemsTablePriceBlockComponent } from './delivery-items-table-price-block/delivery-items-table-price-block.component';
import { DeliveryItemStatusBlockComponent } from './delivery-item-status-block/delivery-item-status-block.component';
import { MenuItem, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IOrderReturnDialogData, OrderReturnDialogComponent } from '../../dialogs/order-return-dialog/order-return-dialog.component';
import { OrderReturnDialogSuccessComponent } from '../../dialogs/order-return-dialog-success/order-return-dialog-success.component';
import { HistoryAndChatDialogComponent } from '../../dialogs/history-and-chat-dialog/history-and-chat-dialog.component';
import { AdjustItemQuantityMutation, AdjustItemQuantityMutationVariables, Order, OrderLine, RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables } from '../../../graphql/generated/generated-types';
import { AssetPreviewPipe } from '../../pipes/asset-preview.pipe';
import { FormatPricePipe } from '../../pipes/format-price.pipe';
import { DataService } from '../../../core/providers/data/data.service';
import { ADJUST_ITEM_QUANTITY, REMOVE_ITEM_FROM_CART } from '../product/price-and-actions-block/product-cart.graphql';
import { Observable, Subject,  of, take } from 'rxjs';
import { OrderStatusBlockComponent } from '../order-status-block/order-status-block.component';
import { ProductImageWrapperComponent } from '../product/product-image-wrapper/product-image-wrapper.component';
import { ToastSeverity } from '../../notification/notification.component';
import { DeleteCartItemBtnBlockComponent } from './delete-cart-item-btn-block/delete-cart-item-btn-block.component';

@Component({
  selector: 'app-delivery-items-table',
  standalone: true,
  imports: [CommonModule, TableModule, ProductDetailsHeaderComponent, ShippingSelectorComponent, 
    QuantitySelectorComponent, RippleModule, DeliveryItemsCardListComponent, 
    DeliveryItemsTableShippingNameComponent, DeliveryItemsTablePriceBlockComponent, 
    DeliveryItemStatusBlockComponent, ButtonModule, MenuModule, OrderReturnDialogComponent, 
    OrderReturnDialogSuccessComponent, HistoryAndChatDialogComponent,
    AssetPreviewPipe, FormatPricePipe, OrderStatusBlockComponent,
    ProductImageWrapperComponent,DeleteCartItemBtnBlockComponent],
  templateUrl: './delivery-items-table.component.html',
  styleUrl: './delivery-items-table.component.scss',
   host: {ngSkipHydration: 'true'},
})
export class DeliveryItemsTableComponent implements OnInit {
  @Input() orderLines: OrderLine[];
  @Input() order: Order;
  @Input() first: boolean = false;

  @Input() inOrder: boolean = false;
  @Input() inCart: boolean = false;
  @Input() inOrderConfirmation!: boolean;
  
  @Input() mobileStylesOnly!: boolean;

  public loading$: Observable<boolean>;
  private unsubscribe$ = new Subject<void>();


  public orderActions: MenuItem[] | undefined = [
    {
      label: 'Arrange return',
      command: (event) => {
        this.openOrderItemReturnDialog();
    }
    },
    {
      label: 'View history and talk',
      command: (event) => {
        this.openOrderHistoryAndChatDialog();
    }
    },
  ]

  constructor(private dialogService: DialogService, private dataService: DataService, private messageService: MessageService){

  }

  ngOnInit(): void {

  }



  public removeItem(id: string) {
    this.loading$ = of(true);
    this.dataService.mutate<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(REMOVE_ITEM_FROM_CART, {
         id,
     }).pipe(
         take(1),
     ).subscribe({
      complete : () => {
        this.loading$ = of(false);
      }
     });
   

   }
  
  setQuantity(event: { itemId: string; quantity: number; }) {
    if (0 < event.quantity) {
        this.adjustItemQuantity(event.itemId, event.quantity);
    } else {
        this.removeItem(event.itemId);
    }
}

private adjustItemQuantity(id: string, qty: number) {
  this.loading$ = of(true);
  this.dataService.mutate<AdjustItemQuantityMutation, AdjustItemQuantityMutationVariables>(ADJUST_ITEM_QUANTITY, {
      id,
      qty,
  }).pipe(
    take(1),
  ).subscribe(({ adjustOrderLine }) => {
      switch (adjustOrderLine.__typename) {
          case 'Order':
              break;
          case 'InsufficientStockError':
          case 'NegativeQuantityError':
          case 'OrderLimitError':
          case 'OrderModificationError':
            this.messageService.add({ severity: ToastSeverity.Error, key: 'notifications', summary: 'Error', detail: `${adjustOrderLine.message}` });
              break;
      }
      this.loading$ = of(false);
  });
}






  public openOrderHistoryAndChatDialog(){
    const dialogRef: DynamicDialogRef = this.dialogService.open(HistoryAndChatDialogComponent,
      {
        data: {
        } as any,
        modal: true,
        dismissableMask: true,
        styleClass: 'c-dialog medium-dialog',
        header: 'View history and talk',
       });

       dialogRef.onClose.subscribe((result) => {
        if(result){

        }})
  }


  public openOrderItemReturnDialog(){
    const dialogRef: DynamicDialogRef = this.dialogService.open(OrderReturnDialogComponent,
      {
        data: {
        } as IOrderReturnDialogData,
        modal: true,
        dismissableMask: true,
        styleClass: 'c-dialog medium-dialog',
        header: 'Arrange return',
       });

       dialogRef.onClose.subscribe((result) => {
        if(result){
          const successDialogRef: DynamicDialogRef = this.dialogService.open(OrderReturnDialogSuccessComponent,
            {
              data: {
              } as any,
              modal: true,
              dismissableMask: true,
              styleClass: 'c-dialog medium-dialog',
              header: 'Arrange return',
             });

             successDialogRef.onClose.subscribe((result) => {

              })
        }
       })
  }
}
